import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { cloneDeep, uniqueId } from 'lodash'
import { ConfigurationCaseTypeLaboratoryCreateRequest, ConfigurationCaseTypeLaboratoryPatchInBatchRequest, ConfigurationCaseTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.dto'
import { initialLocalCasesTypesModalState, LocalCasesTypesModalState, LocalCasesTypesModalTabIndex } from '@/modules/configurationModule/detail/local-cases/local-case-types/components/local-case-types-modal/local-case-types-modal.model'
import LocalCaseTypesModalBasicForm from '@/modules/configurationModule/detail/local-cases/local-case-types/components/local-case-types-modal-basic-form/local-case-types-modal-basic-form.vue'
import LocalCaseTypesModalBasicFormSampleTypes from '@/modules/configurationModule/detail/local-cases/local-case-types/components/local-case-types-modal-basic-form-sample-types/local-case-types-modal-basic-form-sample-types.vue'

@Component({
    components: {
        LocalCaseTypesModalBasicForm,
        LocalCaseTypesModalBasicFormSampleTypes
    }
})
export default class LocalCaseTypesModal extends Vue {
    @Ref() readonly localCaseTypesModal!: any
    @Prop(String) readonly actionTitle!: string
    @Prop(Number) readonly labId!: number
    @Emit()
    update(caseTypePatch: ConfigurationCaseTypeLaboratoryPatchInBatchRequest[]): ConfigurationCaseTypeLaboratoryPatchInBatchRequest[] {
        return caseTypePatch
    }
    @Emit()
    create(caseTypeCreate: ConfigurationCaseTypeLaboratoryCreateRequest): ConfigurationCaseTypeLaboratoryCreateRequest {
        return caseTypeCreate
    }

    state: LocalCasesTypesModalState
    constructor() {
        super()
        this.state = initialLocalCasesTypesModalState()
    }

    get tabsActive(): boolean {
        return !!this.state.selectedRow.id
    }

    async show(selectedRow: ConfigurationCaseTypeLaboratoryResponse): Promise<void> {
        this.state = initialLocalCasesTypesModalState()
        await this.$validator.reset()
        if (selectedRow) {
            this._setSelectedRow(selectedRow)
        }
        this.localCaseTypesModal.show()
        this.forceRenderer()
    }

    hide(): void { this.localCaseTypesModal.hide() }

    forceRenderer(): void {
        this.state.modalUID = uniqueId()
    }

    updateRow(selectedRow: ConfigurationCaseTypeLaboratoryResponse): void {
        this._setSelectedRow(selectedRow)
        this.$nextTick(() => {
            this.state = {
                ...this.state,
                activeTabIndex: LocalCasesTypesModalTabIndex.SAMPLE_TYPES
            }
        })
    }

    spreadEventCaseType(caseType: ConfigurationCaseTypeLaboratoryPatchInBatchRequest | ConfigurationCaseTypeLaboratoryCreateRequest): void {
        if (this.state.selectedRow.id) {
            this.update([caseType as ConfigurationCaseTypeLaboratoryPatchInBatchRequest])
            return
        }
        this.create(caseType as ConfigurationCaseTypeLaboratoryCreateRequest)
    }

    private _setSelectedRow(selectedRow: ConfigurationCaseTypeLaboratoryResponse): void {
        const rowToSend = cloneDeep(selectedRow)
        this.state = {
            ...this.state,
            selectedRow: rowToSend
        }
    }
}
